import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { uniqueId } from 'lodash';
import classnames from 'classnames';

import styles from './DefaultTextareaInput.module.css';

class DefaultTextareaInput extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    activePlaceholder: PropTypes.string,
    className: PropTypes.string,
    inputContainerClassName: PropTypes.string,
    disabled: PropTypes.bool,
    rows: PropTypes.number,
    error: PropTypes.string,

    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    value: '',
    placeholder: null,
    activePlaceholder: null,
    className: null,
    inputContainerClassName: null,
    disabled: false,
    rows: 5,
    error: null,

    onChange: () => {},
    onFocus: null,
    onBlur: null,
  };

  state = {
    active: this.props.value.length !== 0,
    focused: false,
  };

  onFocus = (event) => {
    const { onFocus } = this.props;

    this.setState({
      active: true,
      focused: true,
    });
    if (onFocus) {
      onFocus(event);
    }
  }

  onBlur = (event) => {
    const { onBlur } = this.props;

    this.setState({
      active: event.target.value.length !== 0,
      focused: false,
    });

    if (onBlur) {
      onBlur(event);
    }
  }

  render() {
    const {
      value, placeholder, error, className, disabled, rows, onChange, inputContainerClassName, activePlaceholder
    } = this.props;
    const { active, focused } = this.state;
    const inputId = uniqueId();

    const activePlaceholderName = activePlaceholder || placeholder;

    return (
      <div className={classnames(styles.inputWrapper, className)}>
        <div
          className={classnames(
            inputContainerClassName,
            styles.inputContainer,
            {
              [styles.inputContainerDisabled]: disabled,
              [styles.widthoutPlaceholder]: !placeholder,
              [styles.inputContainerFocused]: focused,
              [styles.inputWithError]: error,
              [styles.inputContainerLabelActive]: active,
            },
          )}
        >
          <label
            htmlFor={`default-textarea-input-${inputId}`}
            className={styles.inputWithLabel}
          >
            {placeholder && (
              <span className={classnames(styles.label, { [styles.labelActive]: active })}>
                {(value || active) ? activePlaceholderName : placeholder}
              </span>
            )}
            <textarea
              id={`default-textarea-input-${inputId}`}
              className={styles.input}
              // type={type || 'text'}
              value={value}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={onChange}
              disabled={disabled}
              rows={rows}
            />
          </label>
        </div>
        {error && (
          <span className={styles.error}>
            {error}
          </span>
        )}
      </div>
    );
  }
}

export default DefaultTextareaInput;
